enum PayablesNewPayableActionType {
    PAYABLES_NEW_PAYABLE_SELECT_CARD = "PAYABLES_NEW_PAYABLE_SELECT_CARD",
    PAYABLES_NEW_PAYABLE_SELECT_STEP = "PAYABLES_NEW_PAYABLE_SELECT_STEP",
}

export default PayablesNewPayableActionType;